import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkApprovalBar = ({ selectedCount, onBulkAction, onClearSelection }) => {
  return (
    <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 mb-4">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex items-center gap-2">
          <Icon name="CheckSquare" size={20} color="var(--color-primary)" />
          <span className="text-sm font-medium text-primary">
            {selectedCount} registration{selectedCount !== 1 ? 's' : ''} selected
          </span>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <Button
            variant="success"
            size="sm"
            onClick={() => onBulkAction('approve')}
            iconName="CheckCircle"
            iconPosition="left"
          >
            Bulk Approve
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => onBulkAction('reject')}
            iconName="XCircle"
            iconPosition="left"
          >
            Bulk Reject
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => onBulkAction('request-info')}
            iconName="MessageSquare"
            iconPosition="left"
          >
            Request Info
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearSelection}
            iconName="X"
            iconPosition="left"
          >
            Clear Selection
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkApprovalBar;